export default __webpack_public_path__ + "static/media/marketwatch-ar21.7b513257.png";